import { ListMembershipsResponseSchema } from './list-memberships.schema';
/**
 * List Memberships Endpoint Contract
 * Returns the workspaces the caller's identity holds an active membership
 * in. Legacy sessions (tokens without an identity claim) receive an empty
 * list.
 */ export const listMembershipsContract = {
    method: 'GET',
    path: '/api/v2/auth/memberships',
    description: "Lists the caller's active memberships as workspace summaries for tenant switching",
    responseSchema: ListMembershipsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Missing or invalid access token'
        }
    }
};

//# sourceMappingURL=list-memberships.contract.js.map